import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Text, useToast } from "@chakra-ui/react";
import ContractInstanceEditor from "./ContractInstanceEditor";
import Navbar from "./Navbar";

const ContractInstanceEditorPage = () => {

  const { productCode, contractId } = useParams();
  const [contract, setContract] = useState(null);
  const [product, setProduct] = useState(null);
  const [contractLoaded, setContractLoaded] = useState(false);
  const [productLoaded, setProductLoaded] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const res = await fetch(
          `https://poc.mrc.ai/${productCode}/api/contracts/${contractId}`
        );
        const data = await res.json();
        setContract(data);
      } catch {
        toast({ title: "Failed to load contract", status: "error" });
      } finally {
        setContractLoaded(true);
      }
    };

    const fetchProduct = async () => {
      try {
        const res = await fetch(
          `https://poc.mrc.ai/${productCode}/api/product`
        );
        const data = await res.json();
        setProduct(data[0]);
      } catch {
        toast({ title: "Failed to load product", status: "error" });
      } finally {
        setProductLoaded(true);
      }
    };

    fetchContract();
    fetchProduct();
  }, [productCode, contractId]);

  if (!contractLoaded || !productLoaded) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />

        <ContractInstanceEditor
          productCode={productCode}
          contractInstance={contract}
          productInstance={product}
          productTemplate={null}
        />

    </Box>
  );
};

export default ContractInstanceEditorPage;
